"use client";

import React from "react";

export default function DrawerPanel({ open, title, onClose, children, widthClass = "max-w-md" }) {
  if (!open) return null;
  return (
    <>
      <button
        type="button"
        aria-label="Close drawer"
        className="fixed inset-0 z-[100000] bg-black/70 backdrop-blur-sm lg:bg-black/55"
        onClick={onClose}
      />
      <aside
        className={`fixed top-0 right-0 z-[100001] h-full w-full ${widthClass} border-l border-gray-800 bg-gray-950 shadow-2xl flex flex-col`}
      >
        <div className="flex items-center justify-between border-b border-gray-800 px-4 py-3">
          <h2 className="text-sm font-semibold text-white">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md p-1 text-gray-500 hover:bg-white/5 hover:text-white"
          >
            ✕
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
      </aside>
    </>
  );
}
